
interface SidebarProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  userRole: string;
}

export default function Sidebar({ selectedCategory, onCategoryChange, userRole }: SidebarProps) {
  const categories = [
    { id: 'all', name: '全部工具', icon: 'ri-apps-line', count: 13 },
    { id: 'system', name: '系统工具', icon: 'ri-settings-line', count: 5 },
    { id: 'scenario', name: '场景工具', icon: 'ri-briefcase-line', count: 4 },
    { id: 'efficiency', name: '效率工具', icon: 'ri-rocket-line', count: 4 }
  ];

  const quickLinks = [
    { name: '我的待办', icon: 'ri-task-line', href: '#' },
    { name: '日程安排', icon: 'ri-calendar-line', href: '#' },
    { name: '团队协作', icon: 'ri-team-line', href: '#' },
    { name: '知识库', icon: 'ri-book-line', href: '#' }
  ];

  return (
    <aside className="fixed left-0 top-16 h-full w-64 bg-white border-r border-gray-200 overflow-y-auto">
      <div className="p-6">
        <div className="mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">工具分类</h2>
          <nav className="space-y-2">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => onCategoryChange(category.id)}
                className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-left transition-colors cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-indigo-50 text-indigo-700 border border-indigo-200'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <i className={`${category.icon} text-lg`}></i>
                  <span className="font-medium">{category.name}</span>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full ${
                  selectedCategory === category.id
                    ? 'bg-indigo-100 text-indigo-700'
                    : 'bg-gray-100 text-gray-600'
                }`}>
                  {category.count}
                </span>
              </button>
            ))}
          </nav>
        </div>

        <div className="mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">快速访问</h2>
          <nav className="space-y-2">
            {quickLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="flex items-center space-x-3 px-3 py-2 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <i className={`${link.icon} text-lg`}></i>
                <span>{link.name}</span>
              </a>
            ))}
          </nav>
        </div>

        <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg p-4 text-white">
          <div className="flex items-center space-x-3 mb-3">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-lightbulb-line text-lg"></i>
            </div>
            <div>
              <h3 className="font-semibold">智能助手</h3>
              <p className="text-sm opacity-90">阿钉</p>
            </div>
          </div>
          <p className="text-sm opacity-90 mb-3">
            需要帮助？让阿钉为您提供智能建议和支持。
          </p>
          <button className="w-full bg-white/20 hover:bg-white/30 text-white py-2 px-3 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
            开始对话
          </button>
        </div>
      </div>
    </aside>
  );
}
